<app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
<div class="modal-header">
  <h3 class="modal-title">Edit Status</h3>
  <button class="fa fa-times" [mat-dialog-close]="" style="float: right;cursor: pointer;background: none;border:none"
    aria-hidden="true"></button>
</div>
<div class="modal-body modal-body-height">
  <div class="overflow-x" style="width: 100%;">
    <div class="row">
      <div class="col-lg-12 oveflow-div" *ngIf="linkedIds.length > 0">
        <div class="link-div" *ngFor="let linkedId of linkedIds">
          <span class="link-id">{{linkedId}}</span>
        </div>
      </div>
      <div class="col-lg-6 mt-2">
        <label class="control-label fw">Status</label>
        <select class="form-control form-control-sm" [(ngModel)]="regulationDetails.status">
          <option *ngFor="let item of closeStatusList" [value]="item.id">
            {{item.title}}
          </option>
        </select>
      </div>
      <div class="col-lg-6 edit_status_changeViewer_group mt-2">
        <div class="control-label fw">Comment</div>
        <mat-form-field class="textarea_field w-100">
          <textarea matInput class="text-area-css" [(ngModel)]="regulationDetails.comment"
            cdkTextareaAutosize></textarea>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <label class="control-label fw">Updated By</label>
        <input type="text" value="{{user.fullName}}" disabled class="form-control form-control-sm" />
      </div>
      <div class="col-lg-6">
        <div class="control-label fw">Division</div>
        <ng-select *ngIf="searchedJuris.length > 0" class="regulation-dialog" [items]="searchedJuris" bindLabel="name" [multiple]="true"
          [(ngModel)]="selectedJuris"  (change)="onChange()">
        </ng-select>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div  class="col-lg-12 cursor-pointer mt-3" (click)="uploadEvidenceAssessment()" >
          <i class="fa fa-upload"></i>
          <span class="text-primary ml-1 fw">Upload Evidence - Assessment
            <i *ngIf="isAssessmentLoader" class="fa fa-circle-o-notch fa-spin"
              style="font-size: .875rem; line-height: 1.5;"></i>
          </span>
          <input id="uploadEviAssessment" (change)="handleFileInput($event.target.files)" type="file" multiple
            style="display: none" #myFileInput /><br />
        </div>
        <div class="col-lg-12 mt-3" *ngIf="impactAssessmentDocument.length > 0">
          <div *ngIf="isFileExist">
            <ng-container *ngFor="let docs of impactAssessmentDocument">
              <div class="file-div text-center" *ngIf="docs.fileType === '1'">
                <span class="fa fa-trash delete-docs pull-right delete-icon" 
                  (click)="openDeleteModel(docs.id, docs.jurisdictionId,'Assessment',docs.fileExtension,docs.fileName,docs.fileUrl)"></span>
                <span class="cursor-pointer"
                  (click)="downloadDocument(docs.id, docs.fileName, docs.fileExtension, 'Assessment',docs.fileUrl)">
                  <i class="fa fa-file-text fa-2x" *ngIf="docs.fileExtension === '.txt'" aria-hidden="true"></i>
                  <i class="fa fa-file-text-o fa-2x"
                    *ngIf="docs.fileExtension === '.eml' || docs.fileExtension === '.msg'" aria-hidden="true"></i>
                  <i class="fa fa-file-pdf-o fa-2x" *ngIf="docs.fileExtension === '.pdf'" aria-hidden="true"></i>
                  <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.doc'" aria-hidden="true"></i>
                  <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.docx'" aria-hidden="true"></i>
                  <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xls'" aria-hidden="true"></i>
                  <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xlsx'" aria-hidden="true"></i>
                  <i class="fa fa-file-o fa-2x" *ngIf="docs.fileExtension === '.csv'" aria-hidden="true"></i>
                  <i class="fa fa-file-code-o fa-2x" *ngIf="docs.fileExtension === '.xml'" aria-hidden="true"></i>
                  <i class="fa fa-file-archive-o fa-2x" *ngIf="docs.fileExtension === '.zip'" aria-hidden="true"></i>
                  <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpeg'" aria-hidden="true"></i>
                  <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpg'" aria-hidden="true"></i>
                  <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.png'" aria-hidden="true"></i>
                  <i class="fa fa-file-powerpoint-o fa-2x"
                    *ngIf="docs.fileExtension === '.ppt' || docs.fileExtension === '.pptx'" aria-hidden="true"></i>
                </span>
                <div class="data-div">{{docs.fileName}}</div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-sm btn-default pull-right" (click)="closeDialog()" cdkFocusInitial>Update</button>
  <button class="btn btn-sm btn-default pull-right" [mat-dialog-close]="">Cancel</button>
</div>
